// -- Endpoints --

// APP
export const APP_GET_DICTIONARY = 'dashboard/dictionary';
export const APP_SWITCH_PARTNER = 'dashboard/switch-partner';

// AUTH
export const AUTH_GET_USER = 'auth/me';
export const AUTH_LOGIN = 'auth/login';
export const AUTH_LOGIN_AS_USER = 'users/:user_id/login-as';

export const AUTH_AUTH0_CALLBACK = 'auth0/callback';
export const AUTH_REGISTER = 'auth/register';
export const AUTH_REFRESH_TOKEN = 'auth/refresh';
export const AUTH_RP_UPDATE = 'auth/password/reset';
export const AUTH_CREATE_PASSWORD = 'auth/password/set';
export const AUTH_RP_SEND_EMAIL = 'auth/password/email';

// REPORTS
export const REPORTS_GET_LIST = 'reports/dictionary';
export const REPORTS_GET_DETAILS = 'reports/:report_type';
export const REPORTS_GENERATE_REPORT = 'reports/:report_type';
export const REPORTS_USER_FIELDS = 'reports/user-fields';
export const REPORTS_GET_DICTIONARY = 'reports/:report_type/dictionary';
export const REPORTS_GET_SCHEDULE_SETTINGS = 'reports/:report_type/schedule';
export const REPORTS_SAVE_SCHEDULE_SETTINGS = 'reports/:report_type/schedule';

// USERS
export const USERS_GET_LIST = 'users';
export const USERS_ADD_USER = 'users';
export const USERS_UPDATE_USER = 'users/:user_id/edit';
export const USERS_ACTIVATE_USER = 'users/:user_id/activate';

// MB USERS
export const PROFILES_GET_LIST = 'mybundle-users';
export const PROFILES_GET_USER_DETAILS = `${PROFILES_GET_LIST}/:user_id`;
export const PROFILES_LOGIN_AS_USER = 'mybundle-users/:user_id/login-as';

// DICTIONARY
export const DICTIONARY_GET = 'users/dictionary';

// DICTIONARY
export const CHARTS_GET_PERIODS = 'charts/periods';
export const CHARTS_GET = 'charts';

// STREAMING REWARDS
export const STREAMING_REWARDS_GET = 'streaming-rewards/:slug';

// SR REPORTS
export const SR_REPORTS_GET_DICTIONARY = 'streaming-rewards/dictionary';
export const SR_REPORTS_GET_DETAILS = 'streaming-rewards/report';
export const SR_OVERVIEW_GET_DICTIONARY = 'streaming-rewards/overview/dictionary';
export const SR_OVERVIEW_GET = 'streaming-rewards/overview';
export const SR_OVERVIEW_AMOUNT_GET = 'streaming-rewards/overview-amount';
export const SR_OVERVIEW_DOWNLOAD_REPORT = 'streaming-rewards/overview';
export const SR_AMOUNT_OVERVIEW_DOWNLOAD_REPORT = 'streaming-rewards/overview-amount';
export const SR_REPORTS_DOWNLOAD_REPORT = 'streaming-rewards';

// SR INVITED USERS
export const SR_INVITED_USERS_EXTEND_INVITE = 'streaming-rewards/invited-users/:invite_id/extend';

// SR USERS
export const SR_USERS_GET_LIST = 'sr-users';
export const SR_USERS_GET_DETAILS = 'sr-users/:user_id';
export const SR_USERS_GET_PAYMENTS = 'sr-users/:user_id/payments';
export const SR_USERS_SEND_TRANSFER_REQUEST = 'sr-users/:user_id/transfer-request';

// WEBHOOKS
export const WEBHOOKS_GET_DICTIONARY = 'streaming-rewards/user/dictionary';
export const WEBHOOKS_ADD_CUSTOMER_CREDITS = 'streaming-rewards/user/add';
export const WEBHOOKS_UPDATE_CUSTOMER_CREDITS = 'streaming-rewards/user/update';
export const WEBHOOKS_CANCEL_CUSTOMER_CREDITS = 'streaming-rewards/user/cancel';

// SETTINGS
export const PARTNER_SETTINGS = 'partners/:partner_id/settings';
